// download-team-pack-and-write-manifest.ts
//
// Nguồn DUY NHẤT của quy tắc "version nào được ghi vào manifest" (#227).
//
// Trước #227 quy tắc này bị CHÉP ở 2 nơi (`commands/sync.ts` nhánh Supabase và
// `lib/team-pack-manager.ts` cho `avatar init`), cả hai cùng ưu tiên version THÔ
// người dùng gõ:  `version ?? objectToVersion(info.object)`. Gõ `--pack-version
// latest` ⇒ manifest nhận CHUỖI "latest" thay vì SemVer thật.
//
// Hệ quả: manifest là nguồn sự thật duy nhất về "đang cài bản nào", nên bẩn ở đây
// làm câm guard hạ cấp #191 ở lần sync KẾ TIẾP (`classifyPackVersionTransition`
// không parse được "latest" ⇒ "unknown" ⇒ im lặng), và làm `avatar status` +
// `sync --dry-run` hiển thị "latest" thay vì version thật.
//
// Quy tắc đúng: version ghi vào manifest LUÔN suy từ `info.object` server trả về.
// Edge fn `get-pack` coi `latest` như KHÔNG truyền và tự resolve qua
// `stable/latest.txt` (`get-pack/index.ts:41-54`) ⇒ `info.object` luôn có dạng
// `pack-<version>.tar.gz`. Với `--pack-version v1.1.40` (version cụ thể) thì
// server trả đúng object đó ⇒ giá trị không đổi so với trước.
import { writePackManifest } from "./pack-manifest-store.js";
import { downloadAndExtractPack, fetchSignedPackUrl } from "./supabase-pack-downloader.js";

// "pack-v0.2.0.tar.gz" → "v0.2.0"
export function objectToVersion(object: string): string {
  return object.replace(/^pack-/, "").replace(/\.tar\.gz$/, "");
}

export interface DownloadedTeamPack {
  installedVersion: string; // version THẬT đã cài (suy từ object name)
  downloadedObject: string; // vd "pack-v1.1.40.tar.gz"
}

// Tải tarball pack + ghi manifest. `requestedVersion` chỉ đi tới SERVER (để pin
// bản), KHÔNG bao giờ đi vào manifest.
//
// `beforeDownload` chạy SAU khi biết version thật, TRƯỚC khi ghi đè thư mục pack —
// chỗ để `avatar sync` cảnh báo hạ cấp (#191) trong khi bản cũ còn nguyên trên đĩa.
export async function downloadTeamPackAndWriteManifest(
  packDir: string,
  idToken: string,
  requestedVersion?: string,
  beforeDownload?: (resolvedVersion: string) => void | Promise<void>,
): Promise<DownloadedTeamPack> {
  const info = await fetchSignedPackUrl(idToken, requestedVersion);
  const resolvedVersion = objectToVersion(info.object);

  if (beforeDownload) await beforeDownload(resolvedVersion);

  await downloadAndExtractPack(info.url, packDir, info.sha256);
  await writePackManifest(packDir, {
    version: resolvedVersion,
    downloadedObject: info.object,
    extractedAt: new Date().toISOString(),
  });

  return { installedVersion: resolvedVersion, downloadedObject: info.object };
}
